<template>
  <span class="mix-note-all-text" :class="{ 'mix-note-text-completed': completed }">
    <a
      href="#"
      v-if="noteTime"
      class="mix-note-text-time"
      @click.prevent="handleTimeClick"
      :style="noteColor"
      >{{ noteTime }}</a
    >
    <font-awesome-icon v-if="completed" icon="check" class="note-check" />{{ noteText }}
    <span v-if="noteNumber" :style="noteColor" class="mix-note-number">{{ noteNumber }}</span>
  </span>
</template>

<style scoped>
.note-check {
  color: rgb(60, 139, 0);
  margin-right: 2px;
}

.mix-note-all-text {
  font-size: 15px;
  font-family: arial;
}

.mix-note-text-time {
  font-family: monospace;
  font-size: 90%;
  margin-right: 5px;
}

.mix-note-number {
  font-style: italic;
  font-weight: 200;
}
</style>

<script>
import { parseNoteTime, noteTimeToNumeric } from "../utils/note_time"

export default {
  props: {
    noteContent: {
      type: String,
      required: true
    },
    completed: {
      type: Boolean,
      default: false
    },
    number: {
      type: Number,
      default: undefined
    },
    color: {
      type: String,
      default: undefined
    }
  },
  methods: {
    handleTimeClick() {
      if (this.noteTime) {
        this.$emit('time-click', noteTimeToNumeric(this.noteTime))
      }
    }
  },
  computed: {
    timeAndText() {
      return parseNoteTime(this.noteContent)
    },
    noteText() {
      return this.timeAndText[0]
    },
    noteTime() {
      return this.timeAndText[1]
    },
    noteNumber() {
      if (this.number == undefined) {
        return ""
      }
      return " (#" + this.number + ")"
    },
    noteColor() {
      return { color: this.color }
    }
  }
}
</script>
